import { useEffect, useState } from "react";
import CategoryLayout from "../layouts/CategoryLayout";
import "./../styles/category.css";
import { HashLoader } from "react-spinners";
import ToastNotification, { showToast } from "../components/toasts/ToastNotification";
import { getProductsByType } from "../api/product.api";
import { AccountCard } from "../components/dashboard/account-section";
import ScrollToTopButton from "../components/scroll-to-top/scroll-to-top-button";
import { TopUpCard } from "../components/dashboard/topup-section";

export const TopUpCategory = () => {
    const [loading, setLoading] = useState(false);
    const [packages, setPackages] = useState([]);

    useEffect(() => {
        fetchTopUpPackages();
    }, []);

    const fetchTopUpPackages = async () => {
        try {
            setLoading(true);
            const res = await getProductsByType("topup_package", 50);

            if (res.success) {
                const activeAccounts = res.data.products?.filter(
                    (acc) => acc.product_status === "active"
                );
                setPackages(activeAccounts);

            }
        } catch (error) {
            showToast(error.message, "error");
        }
        finally {
            setLoading(false);
        }
    }

    return (
        <CategoryLayout title={"Danh mục sản phẩm"}>
            <ToastNotification />
            <ScrollToTopButton />
            {loading ?
                <div style={{ height: "100vh" }} className="loader-container">
                    <HashLoader color="#0d79e2" />
                </div>
                :
                <div className="game-account-category-container">
                    <p>Hiển thị {packages.length} sản phẩm</p>
                    <div className="account-info-container">
                        {packages.length > 0 ?
                            packages.map(acc => (
                                <TopUpCard key={acc._id} pack={acc} status={acc.product_status}/>
                            ))
                            :
                            <p>Hiện tại chưa có sản phẩm</p>}
                    </div>
                </div>
            }
        </CategoryLayout>
    );
};
